import { Button, Divider, Stack } from '@mantine/core';
import React from 'react';

import { AuthenticationMethodType } from '@portals/api/auth';

import { StepSubtitle, StepTitle } from './common';
import { UserCard } from './UserCard';
import { useSignUpWizard } from './wizard/wizard.hooks';

export function Authorized() {
  const { contextData, onNext, setContextData } = useSignUpWizard();

  const removeAuth = () =>
    setContextData((curr) => ({
      email: '',
      auth: null,
      flowType: AuthenticationMethodType.Email,
      classification: null,
    }));

  return (
    <Stack>
      <StepTitle>Welcome to XYTE</StepTitle>
      <StepSubtitle mb="xxl">
        Let's set up your account.
        <br />
        Get started for free. No credit card required.
      </StepSubtitle>

      <UserCard email={contextData.email} name={contextData.name} />

      <Button size="md" onClick={() => onNext()}>
        Continue
      </Button>

      <Divider label="OR" labelPosition="center" />

      <Button size="md" variant="default" onClick={removeAuth}>
        Sign up with a different account
      </Button>
    </Stack>
  );
}
